var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('h1',[_vm._v("404 - "+_vm._s(_vm.$t('error.404.title')))]),_c('p',[_vm._v(_vm._s(_vm.$t('error.404.text')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }